import { Container } from "react-bootstrap";
import "animate.css";
import "../App.css";
import TrackVisibility from "react-on-screen";
import { TraitCards } from "./TraitCards";

export const Banner = () => {
  return (
    <section className="banner" id="home">
      <div className="hero-backdrop">
        <Container>
          <TrackVisibility once>
            {({ isVisible }) => (
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <span className="tagline">B.Tech EE'27 · Minor CS · IITD</span>
                <h1>
                  Engineer who ships
                  <br />
                  across the whole stack
                </h1>
              </div>
            )}
          </TrackVisibility>
          <TraitCards />
        </Container>
      </div>
    </section>
  );
};
